module.exports = __webpack_public_path__ + "static/img/4.336ca38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/admin/4.png
// module id = cTef
// module chunks = 0